/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";
import styled from "@emotion/styled";
import { AnimateSharedLayout, motion } from "framer-motion";
import React from "react";

const Container = styled.div<{ disabled?: boolean }>`
  min-width: 240px;
  max-width: 240px;
  min-height: 40px;
  max-height: 40px;

  padding: 4px;

  background-color: #f4f4f4;
  border-radius: 5px;
  color: #1b1b1b;

  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-gap: 4px;
  transform: "translateZ(0)";

  .title-one {
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;

    cursor: ${(props) =>
      props.disabled ? "not-allowed !important" : "pointer"};

    &.selected {
      width: 100%;
      height: 100%;

      border-radius: 4px;

      font-weight: 600;

      background: #fff;
    }
  }

  .title-two {
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;

    cursor: ${(props) =>
      props.disabled ? "not-allowed !important" : "pointer"};

    &.selected {
      width: 100%;
      height: 100%;

      border-radius: 4px;

      font-weight: 600;

      background: #fff;
    }
  }
`;

interface BlackWhiteListToggleProps {
  selectedBlockCountryType: "BLACKLIST" | "WHITELIST";
  handleChangeCountry: (
    selectedCountry: "BLACKLIST" | "WHITELIST"
  ) => Promise<void>;
  disabled?: boolean;
}

export default function BlackWhiteListToggle({
  selectedBlockCountryType,
  handleChangeCountry,
  disabled,
}: BlackWhiteListToggleProps) {
  return (
    <AnimateSharedLayout>
      <Container disabled={disabled}>
        <motion.div
          animate
          className={`title-one ${
            selectedBlockCountryType === "WHITELIST" && "selected"
          }`}
          onClick={() => {
            if (disabled) return;

            handleChangeCountry("WHITELIST");
          }}
        >
          Whitelist
        </motion.div>
        <motion.div
          animate
          className={`title-two ${
            selectedBlockCountryType === "BLACKLIST" && "selected"
          }`}
          onClick={() => {
            if (disabled) return;

            handleChangeCountry("BLACKLIST");
          }}
        >
          Blacklist
        </motion.div>
      </Container>
    </AnimateSharedLayout>
  );
}
